import axios from "axios";
import { authInterceptor } from "./modules/auth";

export const HTTP = axios.create({
  baseURL: window.env.FORMS_API_URL,
});

export function authHttpFactory(userId, verificationCode = null) {
  const http = axios.create({
    baseURL: window.env.FORMS_API_URL,
  });

  http.interceptors.request.use((requestConfig) =>
    authInterceptor(userId, verificationCode, requestConfig)
  );
  return http;
}

export function downloadFileAuthHttpFactory(userId) {
  const http = axios.create({
    baseURL: window.env.FORMS_API_DOWNLOAD_FILES_URL,
  });

  http.interceptors.request.use((requestConfig) =>
    authInterceptor(userId, null, requestConfig)
  );
  return http;
}
